import { FC } from 'react';
import { type RegisterFlushBlockNoteDocument } from 'further-ui/components';
import { Control, UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import Divider from '@mui/material/Divider';
import GeneralInformation from './GeneralInformation';
import FundOverviewDatapoints from './FundOverviewDatapoints';
import PortfolioUpdateFile from './PortfolioUpdateFile';
import NotificationPreferences from './NotificationPreferences';
import RecipientList from './RecipientList';
import { PeriodEndReportFormValues } from './schema';
import { PeriodEndReport, PeriodEndReportPreview } from './types';

type Props = {
  control: Control<PeriodEndReportFormValues>;
  setValue: UseFormSetValue<PeriodEndReportFormValues>;
  getValues: UseFormGetValues<PeriodEndReportFormValues>;
  readOnly: boolean;
  periodEndReport: PeriodEndReport;
  registerCommentaryFlush: RegisterFlushBlockNoteDocument;
  getPeriodEndReportPreview: () => PeriodEndReportPreview;
};

const AddEditPeriodEndReportForm: FC<Props> = ({
  control,
  setValue,
  getValues,
  readOnly,
  periodEndReport,
  registerCommentaryFlush,
  getPeriodEndReportPreview,
}) => {
  const {
    vehicleId,
    baseCurrency,
    accountingPeriodId,
    periodStart,
    periodEnd,
  } = periodEndReport;
  const formValues = getValues();

  return (
    <>
      <GeneralInformation
        control={control}
        readOnly={readOnly}
        getValues={getValues}
        periodStart={periodStart}
        periodEnd={periodEnd}
        registerCommentaryFlush={registerCommentaryFlush}
      />
      <Divider />
      <FundOverviewDatapoints
        control={control}
        readOnly={readOnly}
        getValues={getValues}
      />
      {!readOnly || formValues.portfolioUpdateFile ? (
        <>
          <Divider />
          <PortfolioUpdateFile control={control} readOnly={readOnly} />
        </>
      ) : null}
      {!readOnly ? (
        <>
          <Divider />
          <NotificationPreferences control={control} setValue={setValue} />
        </>
      ) : null}
      {readOnly ? (
        <>
          <Divider />
          <RecipientList
            control={control}
            vehicleId={vehicleId}
            baseCurrency={baseCurrency}
            accountingPeriodId={accountingPeriodId}
            getPeriodEndReportPreview={getPeriodEndReportPreview}
          />
        </>
      ) : null}
    </>
  );
};

export default AddEditPeriodEndReportForm;
